var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mark-line',{attrs:{"markLineTime":_vm.currentTime,"getPositonOffset":_vm.getPositonOffset,"color":"rgba(255,0,0,.4)"}})}
var staticRenderFns = []

export { render, staticRenderFns }